import { API_DOMAIN, API_PORT, CONTEXT_PATH, OFFLINE_API_PORT } from '../env/variables';

export const fileResourceUrl = (
  token: string,
  value: string,
  filename: string,
  isOffline: boolean = false
) => {
  return `${window.location.protocol}//${API_DOMAIN}:${isOffline ? OFFLINE_API_PORT : API_PORT}${CONTEXT_PATH}/api/download?token=${token}&view=false&value=${value}&filename=${filename}`;
};
